import { render, staticRenderFns } from "./CertificateFields.vue?vue&type=template&id=54c94e85&scoped=true"
import script from "./CertificateFields.vue?vue&type=script&lang=ts"
export * from "./CertificateFields.vue?vue&type=script&lang=ts"
import style0 from "./CertificateFields.vue?vue&type=style&index=0&id=54c94e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c94e85",
  null
  
)

export default component.exports